import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "@/pages/Dashboard";
import SocialKitAdmin from "@/pages/SocialKitAdmin";
import Battery from "@/pages/Battery";
import Community from "@/pages/Community";
import CommunityWall from "@/pages/CommunityWall";
import Report from "@/pages/Report";
import Partners from "@/pages/Partners";
import PartnerCertificate from "@/pages/PartnerCertificate";
import PartnerAttribution from "@/pages/PartnerAttribution";
import FounderProfile from "@/pages/FounderProfile";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Navigate to="/dashboard" replace />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/battery" element={<Battery />} />
                    <Route path="/community" element={<Community />} />
                    <Route path="/community/wall" element={<CommunityWall />} />
                    <Route path="/community/:slug" element={<Community />} />
                    <Route path="/report" element={<Report />} />
                    <Route path="/partners" element={<Partners />} />
                    <Route path="/social-kit" element={<SocialKitAdmin />} />
                    <Route path="/certificates/:slug" element={<PartnerCertificate />} />
                    <Route path="/certificates" element={<Navigate to="/certificates/coaterz" replace />} />
                    <Route path="/partners/:slug" element={<PartnerAttribution />} />
                    <Route path="/impact/:memberSlug" element={<FounderProfile />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
